import { useEffect, useRef } from "react";
import type { BookingWizardState } from "./useBookingCreate";
import { useGuestCheckoutSettings } from "../context/GuestCheckoutSettingsContext";
import { useWidgetAutoExpand } from "../context/WidgetMaximisedContext";

export function useWidgetAutoExpandForPreorder(stage: BookingWizardState["stage"], hasPreorders: boolean): void {
  const requestAutoExpand = useWidgetAutoExpand();
  const { autoExpandForPreorder } = useGuestCheckoutSettings();
  const previousStageRef = useRef(stage);

  useEffect(() => {
    const previousStage = previousStageRef.current;
    previousStageRef.current = stage;
    if (!requestAutoExpand || !autoExpandForPreorder || previousStage === stage) return;
    if (previousStage === "initial" && stage === "details") {
      if (hasPreorders) requestAutoExpand("expand");
    } else if (stage === "initial") {
      requestAutoExpand("restore");
    }
  }, [stage, hasPreorders, requestAutoExpand, autoExpandForPreorder]);
}
